<div class="input form-control" *ngIf="Utility.mobile" (click)="openPopup()">
  <ng-container *ngIf="xModel">{{getTitle(xModel)}}</ng-container>
  <span class="f-medium-gray" *ngIf="!xModel">{{placeholder || '&nbsp;'}}</span>
</div>
<div class="{{Utility.mobile ? 'white-bg z-infinit fixed-fill d-flex flex-column': ''}}"
  *ngIf="!Utility.mobile || popup">
  <div class="d-flex">
    <div class="d-flex align-items-center pointer" (click)="closePopup()" *ngIf="popup">
      <i class="fa fa-arrow-right f-dark-blue fs-xl mr-2"></i>
    </div>
    <div class="location-selector {{popup?'flex-fill no-border no-shadow': 'w-100'}}" [class.search-icon]="searchIcon">
      <ng-select #selector [items]="items$ | async" [ngModel]="xModel" (ngModelChange)="select($event)"
        [selectOnTab]="true" [trackByFn]="trackByFn" [loading]="loading" [typeahead]="searchInput$"
        [placeholder]="placeholder" [minTermLength]="0" notFoundText="شهری با این جستجو یافت نشد"
        [required]="required ? 'required': undefined" loadingText="در حال جستجو . . ." [clearable]="clearIcon"
        [appendTo]="popupSelector" (keydown.enter)="select(xModel)" [inputAttrs]="{type:'search'}">
        <ng-template ng-label-tmp let-item="item">{{getTitle(item,true)}}</ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="d-flex align-items-center justify-content-between" (click)="select(item)">
            <div *ngIf="item._back">
              <i class="fa fa-angle-right"></i>
              بازگشت
            </div>
            {{getTitle(item)}}
            <i class="fa fa-angle-left" *ngIf="item._browse"></i>
          </div>
        </ng-template>
      </ng-select>
      <!-- <i *ngIf="!supportLocating" class="fas fa-map-marker-alt abs-middle pl-2 fs-xl"></i>
      <i *ngIf="supportLocating" class="fas fa-crosshairs abs-middle fs-xl pl-2 locate blink" title="موقعیت فعلی شما"
        (click)="locate()"></i> -->
    </div>
  </div>
  <div [id]="popupId" class="ng-dropdown-panel-container" [class.d-none]="!popup"></div>

</div>